import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataAlert, DialogAlertComponent } from './dialog-alert.component';

@Injectable({
  providedIn: 'root'
})
export class DialogAlertService {

  constructor(private dialog: MatDialog) { }

  openDialogAlert(data: DataAlert) {
    const dialogRef = this.dialog.open(DialogAlertComponent, {
      data: data,
      width: '600px',
    })
    return dialogRef;
  }
}
